import React, { useState, useEffect } from "react";
import { Button, Form, Input, Select, message, Modal, Cascader } from "antd";
import Title from "@/components/Title";
import MyModal from "@components/Modal";
import Area from "@/components/area";
import icon_user_SVIP from "./img/icon_user_SVIP.png";
import icon_user_VIP from "./img/icon_user_VIP.png";
import icon_user_low from "./img/icon_user_low.png";
import supermanger from "./img/super_manage.png";
import Analysisapi from "@/api/analysis";
import RoleApi from "@/api/role";
import md5 from "md5";
import SystemManagement from "@/api/SystemManagement";
import DepartmentApi from "@api/department";
import "./style.css";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const User = ({}) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const [form] = Form.useForm();
  const [formValue, setFormValue] = useState();
  const [id, setId] = useState();
  const [required, setType] = useState(true);
  const [title] = useState("账号管理");
  const [mintitle, setMintitle] = useState();
  const [station, setStation] = useState([]);
  const [okText] = useState("保存");
  const [width] = useState(450);
  const [tag, setTag] = useState(null);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [stationId, setStationId] = useState();
  const [user, setUser] = useState([]);
  const [userName, setUsername] = useState([]);
  const [name, setName] = useState([]);
  const [roleLevel, setRoleLever] = useState();
  const [updateId, setUpdateId] = useState();
  const [placeholder, setPlaceholder] = useState("");
  const [orTag] = useState(1);
  const stationIds = userInfo.stationIds || "-1"; // 获取当前用户的厂站ID
  const [roleData, setRoleData] = useState([]);
  const [businessParamsFlag, setBusinessParamsFlag] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [searchParams, setSearchParams] = useState({
    stationIds: stationIds.split(","),
  });
  const [loading, setLoading] = useState();
  const [deptList, setDeptList] = useState([]);

  useEffect(() => {
    getStation();
    getId();
    getRole();
    getDept();
  }, []);

  useEffect(() => {
    listByPage();
  }, [searchParams]);
  const getId = () => {
    const id = JSON.parse(sessionStorage.getItem("userInfo")).id;
    const name = JSON.parse(sessionStorage.getItem("userInfo")).name;
    const username = JSON.parse(sessionStorage.getItem("userInfo")).realName;
    const roleLevel = JSON.parse(sessionStorage.getItem("userInfo")).roleLevel;
    setId(id);
    setUsername(username);
    setName(name);
    setRoleLever(roleLevel);
  };
  const getRole = () => {
    RoleApi.query({
      pageNum: 1,
      pageSize: 999,
    }).then((res) => {
      if (res.status == 0 && res.data) {
        setRoleData(res.data.data);
      }
    });
  };
  const children = [];
  station.map((item) => {
    children.push(
      <Select.Option
        key={item.id}
        value={JSON.stringify({ name: item.name, id: item.id })}
      >
        {item.name}
      </Select.Option>
    );
  });
  const showBox = (type) => {
    setTag(1);
    setMintitle("新建账户"); //设置弹出框标题为新增
    setPlaceholder("请输入密码");
    setType(true);
    form.resetFields(); //重置一组字段到 initialValues
    setVisible(true); //设置对话框可见
  };
  const update = () => {
    setTag(2);
    setMintitle("修改密码"); //设置弹出框标题为新增
    form.resetFields(); //重置一组字段到 initialValues
    form.setFieldsValue({
      name: name,
    });
    setVisible1(true); //设置对话框可见
  };
  const uUpdate = (obj) => {
    const params = JSON.parse(JSON.stringify(obj));
    params.deptId = findAllParents(deptList, obj.deptId);
    const cDept = findItem(deptList, obj.deptId);
    if (cDept.length > 0 && cDept[0].name == "公司经营层") {
      setBusinessParamsFlag(true);
      let manageDeptList;
      manageDeptList = params.manageDeptList = obj.manageDeptList
        ? obj.manageDeptList.split(",")
        : [];
      form.setFieldsValue({ manageDeptList });
      getlistBusinessDepts(obj.deptId, params.manageDeptList);
    }
    setTag(3);
    setMintitle("修改用户");
    setType(false);
    setPlaceholder("若不需修改密码，不进行填写");
    const stationarr = params.stations.split(",");
    setUpdateId(params.id);
    const newStationarr = [];
    station.map((item) => {
      if (stationarr.indexOf(item.name) > -1) {
        newStationarr.push(JSON.stringify({ name: item.name, id: item.id }));
      }
    });
    let formObj = {
      ...params,
      roleLevel:
        params.roleLevel == 1
          ? "管理员"
          : params.roleLevel == 2
          ? "技术人员"
          : "",
      oldName: params.name,
      confirm: "",
      stations: newStationarr,
      roleIds: params.roleIds ? params.roleIds.split(",") : [],
    };
    setFormValue(formObj);
    setVisible(true);
  };
  const getStation = (params) => {
    Analysisapi.getStation().then((res) => {
      if (res.status == 0 && res.data) {
        const id = res.data[0] ? res.data[0].id : -1;
        setStationId(id);
        setStation(res.data);
      }
    });
  };
  const getStationId = (id) => {
    setSearchParams({
      ...searchParams,
      stationIds: id.split(","),
    });
    setStationId(id);
  };

  const getDept = async () => {
    // 查询部门
    const res = await DepartmentApi.getDeptForTree({});
    if (!res.status) return;
    setDeptList(res.data);
  };

  // 查找所有父元素
  const findAllParents = (map, id) => {
    let t = [];
    for (let i = 0; i < map.length; i++) {
      const e = map[i];
      if (e.id === id) {
        //若查询到对应的节点，则直接返回
        t.push(e.id);
        break;
      } else if (e.children && e.children.length !== 0) {
        //判断是否还有子节点，若有对子节点进行循环调用
        let p = findAllParents(e.children, id);
        //若p的长度不为0，则说明子节点在该节点的children内，记录此节点，并终止循环
        if (p.length !== 0) {
          p.unshift(e.id);
          t = p;
          break;
        }
      }
    }
    return t;
  };

  // 切换部门
  const changeDept = (e) => {
    const id = e[e.length - 1];
    const cDept = findItem(deptList, id);
    if (cDept[0].name == "公司经营层") {
      form.setFieldsValue({ manageDeptList: [] });
      setBusinessParamsFlag(true);
      getlistBusinessDepts(id);
    } else {
      setBusinessParamsFlag(false);
    }
  };

  const getlistBusinessDepts = (id, list) => {
    SystemManagement.listBusinessDepts({ id }).then((res) => {
      if (res.status === "0") {
        if (list && list.length > 0) {
          list.forEach((item) => {
            res.data.map((subItem) => {
              if (subItem.id === item) {
                subItem.isChoosed = true;
              }
            });
          });
          setBusinessList(res.data);
        } else {
          setBusinessList(res.data);
        }
      }
    });
  };

  // 递归查询当前部门数据
  const findItem = (params, id, arr = []) => {
    params.forEach((item) => {
      if (item.id == id) {
        arr.push(item);
      } else {
        findItem(item.children, id, arr);
      }
    });
    return arr;
  };

  const listByPage = () => {
    SystemManagement.list({ ...searchParams }).then((res) => {
      if (res.status == 0) {
        setUser(res.data);
      }
    });
  };
  const submit = () => {
    if (tag == 1) {
      form.validateFields().then((values) => {
        const stationData = values.stations.map((item) => JSON.parse(item));
        const stations = stationData.map((item) => item.name);
        const stationIds = stationData.map((item) => item.id);
        values.deptId = values.deptId[values.deptId.length - 1];
        setLoading(true);
        SystemManagement.addUser({
          ...values,
          pwd: md5(values.pwd),
          stationIds: stationIds.join(","),
          stations: stations.join(","),
          roleIds: values.roleIds.join(","),
          manageDeptList: values.manageDeptList
            ? values.manageDeptList.join(",")
            : undefined,
        })
          .then((res) => {
            setLoading(false);
            if (res.status == 0) {
              message.success("新建成功");
              setSearchParams({
                ...searchParams,
              });
              cancel();
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      });
    }
    if (tag == 2) {
      form.validateFields().then((values) => {
        values.deptId = values.deptId[values.deptId.length - 1];
        setLoading(true);
        SystemManagement.updatePwd({
          ...values,
          oldPwd: md5(values.oldPwd),
          pwd: md5(values.pwd),
          confirm: null,
          id,
        })
          .then((res) => {
            setLoading(false);
            if (res.status == 0) {
              message.success("修改成功");
              setSearchParams({
                ...searchParams,
              });
              cancel();
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      });
    }
    if (tag == 3) {
      form.validateFields().then((values) => {
        values.deptId = values.deptId[values.deptId.length - 1];
        const stationData = values.stations.map((item) => JSON.parse(item));
        const stations = stationData.map((item) => item.name);
        const stationIds = stationData.map((item) => item.id);
        let newPwd = "";
        if (values.pwd == null || values.pwd.length == 0) {
          newPwd = null;
        } else {
          newPwd = md5(values.pwd);
        }
        setLoading(true);
        SystemManagement.updateUser({
          ...values,
          id: updateId,
          roleLevel:
            values.roleLevel == "管理员"
              ? 1
              : values.roleLevel == "技术人员"
              ? 2
              : values.roleLevel,
          stationIds: stationIds.join(","),
          stations: stations.join(","),
          pwd: newPwd,
          roleIds: values.roleIds.join(","),
          manageDeptList: values.manageDeptList
            ? values.manageDeptList.join(",")
            : undefined,
        })
          .then((res) => {
            setLoading(false);
            if (res.status == 0) {
              message.success("修改成功");
              setSearchParams({
                ...searchParams,
              });
              cancel();
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      });
    }
  };
  const deleteUser = (values, e) => {
    e.stopPropagation();
    Modal.confirm({
      title: "提示",
      content: "确认删除该用户吗？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        SystemManagement.deleteUser({ id: values.id }).then((res) => {
          if (res.status == 0) {
            message.success("删除成功");
            setSearchParams({
              ...searchParams,
            });
          }
        });
      },
    });
  };
  const cancel = () => {
    setBusinessParamsFlag(false);
    setFormValue(null);
    form.resetFields();
    setVisible(false);
    setVisible1(false);
  };
  const upRequire = () => {
    setType(true);
  };

  return (
    <div className="baseContent user">
      <div className="column">
        <div className="column1">
          <span>账户: {name}</span>
          {roleLevel == 0 ? (
            <div className="img">
              <img src={supermanger} />
              <p>{userName}</p>
            </div>
          ) : roleLevel == 1 ? (
            <div className="img">
              <img src={icon_user_VIP} />
              <p>{userName}</p>
            </div>
          ) : (
            <div className="img">
              <img src={icon_user_low} />
              <p>{userName}</p>
            </div>
          )}
          {roleLevel == 0 ? (
            <div className="p">
              <p style={{ background: "#E4BB37" }}>超级管理员</p>
              <p>联系方式: {name}</p>
            </div>
          ) : roleLevel == 1 ? (
            <div className="p">
              <p style={{ background: "#2D99FF" }}>管理员</p>
              <p>联系方式: {name}</p>
            </div>
          ) : (
            <div className="p">
              <p style={{ background: "#B5C6D7" }}>技术人员</p>
              <p>联系方式: {name}</p>
            </div>
          )}

          <div className="oneButton" onClick={() => update()}>
            <button>修改密码</button>
          </div>
        </div>
        <div className="column2">
          <Title title={title}></Title>
          <div className="aea">
            <span
              style={{
                position: "absolute",
                marginLeft: "-51px",
                borderBottom: "1px solid #EEF0F3",
                padding: "11px 15px 12px 5px",
                zIndex: "999",
              }}
            >
              厂站:
            </span>
            <Area
              station={station}
              orTag={orTag}
              stationId={stationId}
              getStationId={getStationId}
            />
          </div>
          <div className="list">
            <div className="lists">
              <ul>
                {user.map((item, index) => {
                  if (item.roleLevel == 0) {
                    return (
                      <li key={index}>
                        <img src={icon_user_SVIP} />
                        <p>{item.realName}</p>
                      </li>
                    );
                  }
                })}
              </ul>
              <div className="clear"></div>
            </div>
            <div className="lists">
              <ul>
                {user.map((item, index) => {
                  if (roleLevel == 1 || roleLevel == 2) {
                    if (item.roleLevel == 1) {
                      return (
                        <li style={{ position: "relative" }} key={index}>
                          <img src={icon_user_VIP} />
                          <p>{item.realName}</p>
                          {item.loginFlag == 0 ? (
                            <span
                              className="loginFlag"
                              style={{ position: "absolute" }}
                            >
                              未激活
                            </span>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  } else {
                    if (item.roleLevel == 1) {
                      return (
                        <li
                          style={{ position: "relative" }}
                          key={index}
                          onClick={() => {
                            uUpdate(item);
                          }}
                        >
                          <i
                            className="iconfont iconguanbi"
                            onClick={(e) => {
                              deleteUser(item, e);
                            }}
                          ></i>
                          <img src={icon_user_VIP} />
                          <p>{item.realName}</p>
                          {item.loginFlag == 0 ? (
                            <span
                              className="loginFlag"
                              style={{ position: "absolute" }}
                            >
                              未激活
                            </span>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  }
                })}
              </ul>
              <div className="clear"></div>
            </div>
            <div className="lists">
              <ul>
                {user.map((item, index) => {
                  if (roleLevel == 2) {
                    if (item.roleLevel == 2) {
                      return (
                        <li style={{ position: "relative" }} key={index}>
                          <img src={icon_user_low} />
                          <p>{item.realName}</p>
                          {item.loginFlag == 0 ? (
                            <span
                              className="loginFlag"
                              style={{ position: "absolute" }}
                            >
                              未激活
                            </span>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  } else {
                    if (item.roleLevel == 2) {
                      return (
                        <li
                          style={{ position: "relative" }}
                          key={index}
                          onClick={() => {
                            uUpdate(item);
                          }}
                        >
                          <i
                            className="iconfont iconguanbi"
                            onClick={(e) => {
                              deleteUser(item, e);
                            }}
                          ></i>
                          <img src={icon_user_low} /> <p>{item.realName}</p>
                          {item.loginFlag == 0 ? (
                            <span
                              className="loginFlag"
                              style={{ position: "absolute" }}
                            >
                              未激活
                            </span>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  }
                })}
              </ul>
              <div className="clear"></div>
            </div>
          </div>
          {roleLevel == 0 || roleLevel == 1 ? (
            <div className="listsButton">
              <button onClick={() => showBox()}>
                <i className="iconfont iconfangda"></i>
                &nbsp;&nbsp;&nbsp;新建账户
              </button>
            </div>
          ) : (
            <div></div>
          )}
        </div>

        {visible && (
          <MyModal
            title={mintitle}
            footer={[
              <Button key={1} onClick={cancel} className="abuttons">
                <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
              </Button>,
              <Button
                key={2}
                onClick={submit}
                className="abuttons"
                type="primary"
                loading={loading}
              >
                <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
              </Button>,
            ]}
            visible={visible}
            width={600}
            okText={okText}
            onCancel={() => cancel()}
            onSubmit={() => submit()}
          >
            <div className="userModal">
              <Form
                preserve={false}
                {...layout}
                form={form}
                style={{ marginTop: "20px" }}
                initialValues={formValue}
                autoComplete="off"
              >
                <Form.Item
                  label="人员姓名"
                  name="realName"
                  rules={[{ required: true, message: "请输入名字!" }]}
                >
                  <Input placeholder={"请输入名字"} />
                </Form.Item>

                <Form.Item
                  label="账号"
                  name="name"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^\w+$/),
                      message: "请输入正确的账号",
                    },
                  ]}
                >
                  <Input placeholder={"请输入账号"} />
                </Form.Item>

                <Form.Item
                  label="手机号"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^1(3|4|5|6|7|8|9)\d{9}$/),
                      message: "请输入正确的手机号",
                    },
                  ]}
                >
                  <Input placeholder={"请输入手机号"} />
                </Form.Item>

                <Form.Item name="oldName" style={{ position: "absolute" }}>
                  <Input type="hidden" placeholder={"请输入手机号"} />
                </Form.Item>

                <Form.Item
                  name="roleLevel"
                  label="权限级别"
                  rules={[{ required: true, message: "请选择权限级别!" }]}
                >
                  <Select placeholder="请选择权限级别" allowClear>
                    {roleLevel == 0 ? (
                      [
                        <Select.Option key="1" value="1">
                          管理员
                        </Select.Option>,
                        <Select.Option key="2" value="2">
                          技术人员
                        </Select.Option>,
                      ]
                    ) : roleLevel == 1 ? (
                      <Select.Option key="2" value="2">
                        技术人员
                      </Select.Option>
                    ) : (
                      <Select.Option></Select.Option>
                    )}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="deptId"
                  label="部门"
                  rules={[{ required: true, message: "请选择部门!" }]}
                >
                  <Cascader
                    fieldNames={{
                      label: "name",
                      value: "id",
                      children: "children",
                    }}
                    changeOnSelect
                    options={deptList}
                    placeholder="请选择部门"
                    onChange={changeDept}
                  />
                </Form.Item>
                {businessParamsFlag && (
                  <Form.Item
                    name="manageDeptList"
                    label="经营层所管理部门"
                    rules={[
                      { required: true, message: "请选择经营层所管理部门!" },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="请选择经营层所管理部门"
                      allowClear
                    >
                      {businessList &&
                        businessList.map((v, i) => {
                          return (
                            <Select.Option
                              key={v.id}
                              value={v.id}
                              disabled={v.isChoosed ? false : true}
                            >
                              {v.name}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                )}
                <Form.Item
                  name="roleIds"
                  label="角色级别"
                  rules={[{ required: true, message: "请选择角色级别!" }]}
                >
                  <Select
                    mode="multiple"
                    placeholder="请选择角色级别"
                    allowClear
                  >
                    {roleData &&
                      roleData.map((v, i) => {
                        return (
                          <Select.Option key={"role" + i} value={v.id}>
                            {v.name}
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="stations"
                  label="厂站管理"
                  rules={[{ required: true, message: "请选择厂站!" }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="请选择厂站"
                  >
                    {children}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="pwd"
                  label="初始密码"
                  hasFeedback
                  rules={[
                    {
                      required: required,
                      pattern: new RegExp(/^(?![^a-zA-Z]+$)(?!\\D+$).{8,16}$/),
                      message: "请输入包括数字和字母、长度8到16位的密码组合!",
                    },
                  ]}
                  onChange={upRequire}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={placeholder}
                  />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label="密码确认"
                  dependencies={["sysAdminPwd"]}
                  hasFeedback
                  rules={[
                    {
                      required: required,
                      message: "请再次输入密码!",
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("pwd") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject("密码不一致,请重新输入!");
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={"请再次输入密码"}
                  />
                </Form.Item>
              </Form>
            </div>
          </MyModal>
        )}
        {visible1 && (
          <MyModal
            title={mintitle}
            footer={[
              <Button key={1} onClick={cancel} className="abuttons">
                <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
              </Button>,
              <Button
                key={2}
                onClick={submit}
                className="abuttons"
                type="primary"
                loading={loading}
              >
                <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
              </Button>,
            ]}
            visible={visible1}
            width={width}
            okText={okText}
          >
            <div className="userModal">
              <Form
                {...layout}
                form={form}
                style={{ marginTop: "20px" }}
                autoComplete="off"
              >
                <Form.Item
                  name="name"
                  label="登录账号"
                  hasFeedback
                  rules={[{ required: true, message: "请输入账号!" }]}
                >
                  <Input placeholder={"请输入账号"} />
                </Form.Item>

                <Form.Item
                  name="oldPwd"
                  label="旧密码"
                  rules={[{ required: true, message: "请输入密码!" }]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={"请输入密码"}
                  />
                </Form.Item>

                <Form.Item
                  name="pwd"
                  label="新密码"
                  hasFeedback
                  rules={[
                    {
                      required: required,
                      pattern: new RegExp(/^(?![^a-zA-Z]+$)(?!\\D+$).{8,16}$/),
                      message: "请输入包括数字和字母、长度8到16位的密码组合!",
                    },
                  ]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={"请输入密码"}
                  />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label="密码确认"
                  dependencies={["sysAdminPwd"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "请再次输入密码!",
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("pwd") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject("密码不一致,请重新输入!");
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    placeholder={"请再次输入密码"}
                  />
                </Form.Item>
              </Form>
            </div>
          </MyModal>
        )}
      </div>
    </div>
  );
};

export default User;
